export type SpeedTestStatus =
  | 'idle'
  | 'preparing'
  | 'ping'
  | 'download'
  | 'upload'
  | 'completed'
  | 'failed'
  | 'aborted';

export interface SpeedTestSnapshot {
  status: SpeedTestStatus;
  downloadMbps: number | null;
  uploadMbps: number | null;
  pingMs: number | null;
  jitterMs: number | null;
  downloadProgress: number;
  uploadProgress: number;
  pingProgress: number;
  errorMessage: string | null;
}

export const INITIAL_SPEED_TEST_SNAPSHOT: SpeedTestSnapshot = {
  status: 'idle',
  downloadMbps: null,
  uploadMbps: null,
  pingMs: null,
  jitterMs: null,
  downloadProgress: 0,
  uploadProgress: 0,
  pingProgress: 0,
  errorMessage: null,
};

export function isSpeedTestRunning(status: SpeedTestStatus): boolean {
  return status === 'preparing' || status === 'ping' || status === 'download' || status === 'upload';
}

export type SpeedTestMode = 'live' | 'scenario';
